export default "__VITE_ASSET__48cea13b__"